module.exports = __webpack_public_path__ + "static/media/radsite.7e219301.jpg";